module.exports = __webpack_public_path__ + "img/block-3.2dbf5eac.jpg";